module.exports = __webpack_public_path__ + "img/06.61f4820d.png";